import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Pusher from "pusher-js";

const pusher = new Pusher("e755eaaf697e7362a61f", {
  cluster: "us2", // e.g., 'us2'
  forceTLS: true,
});

Vue.prototype.$pusher = pusher;

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

if (process.env.NODE_ENV == "production") {
  Vue.prototype.$url = ".yomefacturo.mx";
  Vue.prototype.$protocolo = "https://";
} else {
  Vue.prototype.$url = ".ymf.test";
  Vue.prototype.$protocolo = "http://";
}

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
